<div class="popup">
    <p *ngIf="success == true" class="success-popup">Saved!</p>
    <p *ngIf="success == false" class="reject-popup">Rejected!</p>
</div>

<div class="container" *ngIf="isSkeltonLoad">
    <div class="row">
        <div class="col main oldpassword" *ngFor="let item of skeltonArray">
            <form class="form-skelton">
                <div class="headingSkelton"></div>
                <div class="textSkelton">
                    <div class="textsmSkelton"></div>
                </div>
                <div class="textSkelton"></div>
                <div class="textSkelton"></div>
                <div class="box">
                    <div class="textBoxSkelton"></div>
                </div>

                <div class="headingSkelton"></div>
                <div class="textSkelton"></div>
            </form>
        </div>
    </div>
</div>
<div class="container wrapper" *ngIf="!isSkeltonLoad">
    <div class="row" *ngIf="!cancelled">
        <div class="col main">
            <form>
                <div class="heading">
                    <p class="subscription-heading">Your Subscriptions</p>
                </div>
                <div class="line"></div>
                <div class="content">
                    <div class="">
                        <p class="allaccess-txt">WindowSwap All-Access</p>
                        <p class="subscription-txt">${{amount}} {{planType}}</p>
                        <p class="auto-renew">Auto renews on {{subscriptionEnds}}</p>
                    </div>
                    <div class="payment-method">
                        <p class="payment-txt">Payment method</p>
                        <div class="card-main" id="card-num">
                            <div class="card-num" aria-disabled="cardisChanging" *ngFor="let data of cardNumber"
                                (click)="changeDefaultCard(data)"><img class="card-img"
                                    src="{{data.brand_img}}">...{{data.last4}} <span *ngIf="data.selected"
                                    class="default-txt">Default</span>
                                <span class="arrow"></span>
                            </div>
                            <div class="addcardtxt" (click)="addnewcard()"> + Add new Card</div>
                        </div>
                    </div>
                </div>
                <div class="cancel-subscription">
                    <p class="cancel-subscription-txt" (click)="openConfirmModal()">Cancel Subscription</p>
                </div>
            </form>
        </div>
    </div>
    <div class="row" *ngIf="cancelled">
        <div class="col main">
            <form>
                <div class="heading">
                    <p class="subscription-heading">Your Subscriptions</p>
                </div>
                <div class="line"></div>
                <p class="allaccess-txt-cancel">(Canceled)WindowSwap All-Access</p>
                <p class="subscription-txt">${{amount}} {{planType}}</p>
                <div class="save-div">
                    <button class="save" type="submit" (click)="renewSubscription()">
                        <span *ngIf="isloading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                        Renew Subscription
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="container mobile-wrapper" *ngIf="!isSkeltonLoad">
    <div class="row" *ngIf="!cancelled">
        <div class="col main">
            <form [ngStyle]="{ height: windowWidth}">
                <div class="heading">
                    <p class="subscription-heading">Your Subscriptions</p>
                </div>
                <div class="whole-wrapper">
                    <div class="">
                        <p class="allaccess-txt">WindowSwap All-Access</p>
                        <p class="subscription-txt">${{amount}} {{planType}}</p>
                        <p class="auto-renew">Auto renews on {{subscriptionEnds}}</p>
                    </div>
                    <div class="card-div">
                        <span class="payment-txt">Payment method</span>
                        <div class="card-main">
                            <div class="card-num" *ngFor="let data of cardNumber" (click)="changeDefaultCard(data)"><img
                                    class="card-img" src="{{data.brand_img}}">...{{data.last4}} <span
                                    *ngIf="data.selected" class="default-txt">Default</span> <span class="arrow"></span>
                            </div>
                            <div class="addcardtxt" (click)="addnewcard()"> + Add new Card</div>
                        </div>
                    </div>
                    <div class="cancel-subscription">
                        <p class="cancel-subscription-txt" (click)="openConfirmModal()">Cancel Subscription</p>
                    </div>
                </div>
                <div class=""></div>
            </form>
        </div>
    </div>
    <div class="row" *ngIf="cancelled">
        <div class="col main">
            <form>
                <div class="heading">
                    <p class="subscription-heading">Your Subscriptions</p>
                </div>
                <div class="line"></div>
                <p class="allaccess-txt-cancel">(Canceled)WindowSwap All-Access</p>
                <p class="subscription-txt">${{amount}} {{planType}}</p>
                <div class="save-div">
                    <button class="save" type="submit" (click)="renewSubscription()">
                        <span *ngIf="isloading" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                        Renew Subscription
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- confirm modal -->

<div class="modal-popup" id="modal-popup-confirm" *ngIf="showconfirmModal">
    <div class="confirm-popup-content popup-content-confirm">
        <div class="popup-content-confirm-margin">
            <h1>Sure you want to cancel <br> your subscription to All-Access?</h1>
        </div>
        <button [disabled]="isRemoving" type="button" class="yes-button" (click)="cancelSubscription()">
            <div *ngIf="isRemoving" class="spinner-border removing-spinner" role="status">
                <span class="sr-only">{{constants.LOADING_TEXT}}</span>
            </div>
            <div *ngIf="!isRemoving">{{constants.YES}}</div>
        </button>
        <button type="button" class="no-button" (click)=onClickCloseConfirmPopup()>
            {{constants.NO}}
        </button>
    </div>
</div>